module.exports = "/fonts/icomoon.eot?f1053e8bef551a9fc6c97d16109af814";